"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const redux_observable_1 = require("redux-observable");
const floor = __importStar(require("./floor"));
const mode = __importStar(require("./mode"));
const sandbox = __importStar(require("./sandbox"));
const user = __importStar(require("./user"));
__export(require("./enums"));
exports.rootReducer = redux_1.combineReducers(Object.assign(Object.assign(Object.assign(Object.assign({}, floor.reducers), mode.reducers), sandbox.reducers), user.reducers));
exports.actions = Object.assign(Object.assign(Object.assign(Object.assign({}, floor.actions), mode.actions), sandbox.actions), user.actions);
exports.rootEpic = redux_observable_1.combineEpics(floor.epic, mode.epic, sandbox.epic, user.epic);
function createGamebookStore() {
    const epicMiddleware = redux_observable_1.createEpicMiddleware();
    const store = redux_1.createStore(exports.rootReducer, redux_1.applyMiddleware(epicMiddleware));
    epicMiddleware.run(exports.rootEpic);
    return store;
}
exports.createGamebookStore = createGamebookStore;
